<script setup lang="ts">
const { locales } = useLocales();
</script>

<template>
  <a :href="locales?.current.url || '/'" class="inline-block">
    <SvgLogoMuniles class="h-12 w-auto max-w-[90%]" />
  </a>
</template>
